import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./App.css";
import translations from "./translations.js";
import engineData from "./engineData.js";
import fusotransparent from "./assets/fuso-transparent.svg";
import sendIcon from "./assets/send-icon.svg";
import userImage from "./assets/user.png";
import uploadIcon from "./assets/upload.png";
import newChat from "./assets/new-message.png";
import fusoLogo from "./assets/fuso-logo.svg";
import about from "./assets/about.png";
import Shimmer from "./shimmer/shimmer.js";
import FeatureCard from "./cards/cards.js";
import Modal from "./aboutPage/Modal.js";
import dots from "./assets/three-dot-menu.png";
import deleteIcon from "./assets/delete.png";
import "./i18n";

const data = engineData;


// Using relative URLs to leverage the proxy configuration
const ASCENT_SERVER_URL = "/v1/fuso-ascent/";

// Using relative URLs to leverage the proxy configuration
const SHOP_MODULE_SERVER_URL = "/v1/shop-manual/";



function App({ selectedModule }) {

  const [messages, setMessages] = useState([]);
  const [question, setQuestion] = useState("");
  const [engineFilter, setEngineFilter] = useState("");
  const [modelFilter, setModelFilter] = useState("");
  const [langOpt, setLangOpt] = useState(
    localStorage.getItem("langOpt") || "Japanese"
  );
  const [response, setResponse] = useState("");
  const [solutions, setSolutions] = useState({});
  const [selectedCase, setSelectedCase] = useState("");
  const [showActions, setShowActions] = useState(false);
  const [isAwaitingResponse, setIsAwaitingResponse] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [engineModels, setEngineModels] = useState([]);
  const [models, setModels] = useState([]);
  const [accessToken, setAccessToken] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [userId, setUserId] = useState(localStorage.getItem("userId") || null);
  const [isBotLooking, setIsBotLooking] = useState(false);
  const [hasCopied, setHasCopied] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [historyMessages, setHistoryMessages] = useState([]);
  const messageSection = useRef(null);
  const [childFunc, setChildFunc] = useState(null);
  const [childQueryFunc, setChildQueryFunc] = useState(null);
  const [removeChatFunc, setRemoveChatFunc] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [assistantHasResponded, setAssistantHasResponded] = useState(false);
  const [previewAfterSend, setPreviewAfterSend] = useState(null);
  const [base64Image, setBase64Image] = useState(""); 
  const [base64SegImage, setBase64SegImage] = useState("");
  const [imageFile, setImageFile] = useState(null); 
  const fileInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [chatId, setChatId] = useState(null);
  const [chatHistoryData, setChatHistoryData] = useState([]);
  const headerToolbarRef = useRef(null);

  const [userInputs, setUserInputs] = useState([]);
  const [selectedQueries, setSelectedQueries] = useState([]);
  const [selectedQuery, setSelectedQuery] = useState([]);
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [visibleMenu, setVisibleMenu] = useState(null);
  const [chatToDelete, setChatToDelete] = useState(null);
  const [deleteSuccessMessage, setDeleteSuccessMessage] = useState(false);
  const [chats, setChats] = useState([]);
  


  const SERVER_URL =
    selectedModule === "Ascent" ? ASCENT_SERVER_URL : SHOP_MODULE_SERVER_URL;

  const CHAT_SERVER_URL = SERVER_URL + "text-search-v2";
  const IMAGE_SERVER_URL = SERVER_URL + "image-search";
  const CHAT_HISTORY = SERVER_URL + "chat-history";
  const CHAT_HISTORY_ID = SERVER_URL + "chat-history-id";

  const CHAT_HISTORY_DELETE = SERVER_URL + "clear_chat";


  const handleChatHistoryData = (data) => {

    setChatHistoryData(data.data);
  };

  const visibleItems = Array.isArray(chatHistoryData)
    ? isExpanded
      ? chatHistoryData
      : chatHistoryData.slice(0, 4)
    : [];

  const handleUserInputs = (queries) => {
    setSelectedQueries(queries);
  };

  const handleSendQuery = (query) => {
    setSelectedQuery(query); 
  };

  const handleChatHistory = async () => {
    try {
      const response = await axios.get(`${CHAT_HISTORY}?user_id=${userId}`);
      let chatHistoryData = response?.data.data;

      chatHistoryData = chatHistoryData.flat();

      // Sort the chat history data in ascending order based on the time property
      chatHistoryData = chatHistoryData.sort((a, b) => {
        const timeA = new Date(a.timestamp).getTime();
        const timeB = new Date(b.timestamp).getTime();
        return timeB - timeA; 
      });

      setChatHistoryData(chatHistoryData);
      setChatHistoryData(chatHistoryData);
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const toggleSidebar = () => {
    // console.log('toggle from app.js')
    setSidebarVisible((prevState) => !prevState);
  };

  const triggerQueryChildFunction = () => {
    if (childQueryFunc) {
      childQueryFunc();
    }
  };

  const toggleMenu = (chatId) => {
    setMenuOpenId(menuOpenId === chatId ? null : chatId);
  };
  const handleSelect = async (item) => {
    setSelectedIndex(item);
    triggerQueryChildFunction();
    setVisibleMenu(null);

    const chat_id = item;

    try {
      const result = await axios.get(`${CHAT_HISTORY_ID}?chat_id=${chat_id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const historyDetails = result.data.data;
      openHistory(historyDetails);
    } catch (error) {
      console.error("Error fetching chat history details:", error);
    }
  };

  const handleItemClick = (id) => {
    setSelectedItemId(id);
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
  }, [messages]);

  useEffect(() => {
    const assistantMessage = messages.some(
      (message) => message.role === "assistant" || message.role === "user"
    );
    setAssistantHasResponded(assistantMessage);
  }, [messages]);

  useEffect(() => {
    localStorage.getItem("profileImage")
      ? setProfileImage(localStorage.getItem("profileImage"))
      : setProfileImage(userImage);
  }, [profileImage]);

  useEffect(() => {
    setMessages(historyMessages);
  }, [historyMessages]);

  useEffect(() => {
  }, [messages]);

  const openHistory = (message) => {
    // debugger
    setSelectedCase(null);
    if (Array.isArray(message)) {
      const sortedMessages = message?.sort((a, b) => {
        const timeA = new Date(a.timestamp).getTime();
        const timeB = new Date(b.timestamp).getTime();
        return timeA - timeB; 
      });

      const newMessages = sortedMessages
        .map((entry) => {
          let assistantResponseContent = "No response available";
          let queryImage = null;
          let main_image = null;

          let isMultipleResults = false;
          if (entry?.ai_answer) {
            if (typeof entry.ai_answer === 'string') {
              assistantResponseContent = entry.ai_answer;
            } else if (Array.isArray(entry.ai_answer)) {
              if (entry.ai_answer.length > 1) {
                isMultipleResults = true; 
              }
              assistantResponseContent = entry.ai_answer
                .map((answer) => {
                  const hasSingleObject = Array.isArray(answer) ? answer.length === 1 : false;
                  return `
                    <div class="${hasSingleObject ? 'singleObjectClass' : 'multipleObjectsClass'}">
                      <ul class="custom-ul-class">
                        ${Object.entries(answer)
                      .map(([key, value]) => `<li class="custom-li-class"><b>${key}:</b> ${value}</li>`)
                      .join("")}
                      </ul>
                    </div>
                  `;
                })
                .join("\n\n");
            } else {
              assistantResponseContent = `
                <ul>
                  ${Object.entries(entry.ai_answer)
                  .map(([key, value]) => `<li><b>${key}:</b> ${value}</li>`)
                  .join("")}
                </ul>
              `;
            }
          }

          if (entry?.user_image_question) {
            queryImage = `data:image/png;base64,${entry.user_image_question}`;
          }

          // Process ai_image_answer (if available)
          if (entry?.ai_image_answer) {
            main_image = `data:image/png;base64,${entry.ai_image_answer}`;
          }

          if (!assistantResponseContent && !main_image) {
            assistantResponseContent = "No response available";
          }

          return [
            { role: "user", content: entry?.user_question, queryImage },
            {
              role: "assistant",
              content: assistantResponseContent,
              base64Image: main_image,
            },
          ];
        })
        .flat();

      if (!Array.isArray(newMessages) || newMessages.length === 0) {
        console.error("Failed to transform messages:", newMessages);
        return;
      }

      setMessages(newMessages);
    }

    setShowActions(true);
    setSelectedChat(message[0]?.chat_id);
    setChatId(message[0]?.chat_id);
    setSelectedCase("");
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("chat-bot");
    if (storedToken) {
      setAccessToken(storedToken.replace(/^"|"$/g, ""));
    }
  }, []);

  const handleBlur = () => {
    setIsBotLooking(false);
  };

  const handleNewChat = () => {
    const newMessages = [];
    resetSectedChat();
    setSelectedCase("");
    setSelectedChat(null);
    setModelFilter("");
    setEngineFilter("");
    setMessages(newMessages);
    setChatId(null);
  };

  useEffect(() => {
  }, [question]);

  const handleChange = (e) => {
    if (e.target.value.length > 0) {
      setIsBotLooking(true);
    } else {
      setIsBotLooking(false);
    }
    setQuestion(e.target.value);
  };

  const translate = (text) => {
    return langOpt === "Japanese" ? translations[text] : text;
  };

  const triggerChildFunction = (historyResponse) => {
    if (childFunc) {
      childFunc(historyResponse); 
    }
  };

  const resetSectedChat = () => {
  };

  const handleSendMessage = async (selectedQuery) => {
    let currentQuestion = question;

    if (selectedQuery.length === 0 && !imageFile) return;

    if (!question && selectedImage) {
      alert("Please add text along with the image.");
      return;
    }

    setIsAwaitingResponse(true);
    // let currentQuestion = question;
    let chat_id = null;
    let result;

    if (imageFile) {
      const imageUrl = URL.createObjectURL(imageFile);
      setMessages((prevMessages) => [
        ...prevMessages,
        { role: "user", content: currentQuestion, queryImage: imageUrl }, 
      ]);
      // handleUserHistory(currentQuestion, result.data);
    } else {
      const formattedContent = selectedQuery
        .map((item) => {
          return Object.entries(item)
            .map(([key, value]) => {
              const formattedKey = key
                .split("_")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
              return `<b>${formattedKey}</b>: ${value}`;
            })
            .join("</br>");

        })
        .join("</br>");

      setMessages((prevMessages) => [
        ...prevMessages,
        {
          role: "user",
          content: `${formattedContent}<br />${currentQuestion}`,
        }, // Append assistant message without image
      ]);
    }
    setQuestion("");
    handleRemoveImage();
    try {
      const displayId = chatId !== null ? chatId : null;

      if (imageFile) {
        // Image search flow
        const displayId = chatId !== null ? chatId : null;
        const formData = new FormData();
        formData.append("user_query_image", imageFile);
        formData.append("user_question", currentQuestion);
        formData.append("existing_chat_id", displayId);
        formData.append("chat_id", chatId);
        formData.append("user_id", userId);

        // Call image-search API
        result = await axios.post(IMAGE_SERVER_URL, formData);
        const description = result.data?.description;
        // const description = result.data?.descrption_new;
        const base64Image = result.data?.predicted_image_b64;


        // if (!description) throw new Error("No response from image search API");
        const response = result?.data;
        const chat_id = response?.chat_id;
        const main_image = response?.image;
        setChatId(chat_id);

        setMessages((prevMessages) => [
          ...prevMessages,
          { role: "assistant", content: description, base64Image, main_image }, 
        ]);
      } else {

        const displayId = chatId !== null ? chatId : null;

        let body = {
          user_query: currentQuestion,
          existing_chat_id: displayId,
          user_id: userId,
        };
        if (selectedQuery.length > 0) {
          selectedQuery.forEach((item) => {
            Object.keys(item).forEach((key) => {
              body[key] = item[key];
            });
          });
        }
        result = await axios.post(CHAT_SERVER_URL, body);
        if (!result || !result.data) {
          throw new Error("No response from text search API");
        }

        const response = result.data;
        const chat_id = response?.chat_id;
        // const description = response?.description;
        const description = result.data?.descrption_new;
        const main_image = response?.image;

        setChatId(chat_id);
        const normalizedDescription = Array.isArray(description)
          ? description
          : description
            ? [description]
            : [];

        if (normalizedDescription.length > 0) {
          let formattedDescription = "";

          // Check if there's only one object
          const hasSingleObject = normalizedDescription.length === 1;

          const isMultipleResults = normalizedDescription.length > 1;
          formattedDescription += normalizedDescription
            .map((item) => {
              const entries = Object.entries(item);
              const className = hasSingleObject
                ? "singleObjectClass"
                : "multipleObjectsClass";

              return `<div class="${className}"><ul class="custom-ul-class">${entries
                .map(
                  ([key, value]) =>
                    `<li class="custom-li-class"><b>${key}:</b> ${value}</li>`
                )
                .join("")}</ul></div>`;
            })
            .join("<br />");
          setMessages((prevMessages) => [
            ...prevMessages,
            { role: "assistant", content: `${formattedDescription} <br />`, main_image },
          ]);
        } else {
          setMessages((prevMessages) => [
            ...prevMessages,
            { role: "assistant", content: "No description available.", main_image },
          ]);
        }
      }
      try {
        handleChatHistory();
      } catch (error) {
        console.error("Error fetching chat history:", error);
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            role: "assistant",
            content: "Some error occured. Please try again.",
          },
        ]);
      }

      // Clear input and image preview after sending
      setQuestion("");
      handleRemoveImage(); 
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; 
      }
    } catch (error) {
      console.error("Error sending message:", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { role: "assistant", content: "Some error occured. Please try again." },
      ]);
    } finally {
      setIsAwaitingResponse(false);
      setTimeout(() => {
        messageSection?.current?.scrollTo({
          top: messageSection.current.scrollHeight,
          behavior: "smooth",
        });
      }, 200);
    }

    if (headerToolbarRef.current) {
      headerToolbarRef.current.handleChatHistory(); 
    }
  };
  const handleKeyPress = (event, selectedQuery) => {

    if (event.key === "Enter") {
      if (!event.shiftKey) {
        event.preventDefault();
        handleSendMessage(selectedQuery);
      }
    }
  };

  const selectCase = (caseId) => {
    setSelectedCase(caseId);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
        setImageFile(file); 
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setImageFile(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = ""; 
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const month = String(date.getMonth() + 1).padStart(2, "0"); 
    const day = String(date.getDate()).padStart(2, "0");
    return `${month}/${day}`;
  };


  useEffect(() => {
    // Close the menu when clicking outside
    const handleClickOutside = (e) => {
      if (
        !e.target.closest('.fui-TreeItemLayout') && 
        !e.target.closest('.menu1') && 
        !e.target.closest('.dotMenu1')
      ) {
        setMenuOpenId(null); // Close the menu
      }
    };

    // Add event listener to close the menu on outside click
    document.addEventListener('click', handleClickOutside);

    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleDotsClick = (e, itemId) => {
    e.stopPropagation();
    setMenuOpenId(menuOpenId === itemId ? null : itemId); 
  };

  const handleTitleClick = (itemId) => {
    setMenuOpenId(null);
    handleSelect(itemId);
  };

  const handleDeleteClick = (chatId) => {
    setChatToDelete(chatId); 
    setIsModalOpen(true); 
  };

  //API for Delete History of Ascent
  const handleDelete = async (chatId) => {
    // debugger
    if (chatId) {
      try {
        const response = await axios.post(CHAT_HISTORY_DELETE, {
          chat_id: chatId, 
        });
        if (response.status === 200) {
          setMessages([]);
          setDeleteSuccessMessage(true);
          setTimeout(() => {
            setDeleteSuccessMessage(false); 
          }, 3000);

          const updatedChats = handleChatHistory(); 
          setChats(updatedChats);
        } else {
          console.error("Failed to delete chat");
        }
      } catch (error) {
        console.error("Error deleting chat:", error);
      }
      setIsModalOpen(false);
      setChatToDelete(null);
    }
  };

  return (
    <div className="App scroll-div">
       {deleteSuccessMessage && (
        <div className="successMessage">
          Chat deleted successfully!
        </div>
      )}
      <div
        className={`content ${langOpt === "English" ? "jakartaFont" : "japaneseFont"
          }`}
      >
        <main className={`main ${sidebarVisible ? "" : "full-width"}`}>
          {sidebarVisible && (
            <aside className="sidebar open">
              <div className="sidebar-content">
                {/* Sidebar Header */}
                <div className="sidebar-header">
                  <div className="chat-bot"></div>
                </div>
                {/* Chat History Section */}
                <div className="sidebar-section">
                  <div className="hisBtn">
                    <button
                      className="history show-on-small-screen"
                      onClick={toggleSidebar}
                    >
                      <span className="hisIcon">
                        {sidebarVisible ? (
                          <svg
                            className="fui-Icon-filled ___1vjqft9 fjseox fez10in fg4l7m0"
                            fill="currentColor"
                            aria-hidden="true"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m9.18 10.5-1 .87a.5.5 0 1 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H5.5a.5.5 0 0 0 0 1h3.68ZM16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12ZM12 5v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8Z"
                              fill="currentColor"
                            />
                          </svg>
                        ) : (
                          <svg
                            className="fui-Icon-regular"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m6.82 10.5 1 .87a.5.5 0 0 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .66.76l-1 .87h3.68a.5.5 0 0 1 0 1H6.82ZM18 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8Zm-2 1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3v10h3Zm-4 0V5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8Z"
                              fill="currentColor"
                            ></path>
                          </svg>
                        )}
                      </span>
                    </button>
                  </div>
                  <div className="chatHead">
                    <div className="chatMain">
                      <span className="fui-Caption1Strong">Chats</span>
                    </div>
                    {visibleItems.length > 4 && (
                      <div className="showMore">
                        <button className="showBtn" onClick={toggleExpand}>
                          <span className="showSpan">
                            {isExpanded ? "Show Less" : "Show More"}
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="chatGroup">
                    {Array.isArray(chatHistoryData) &&
                      chatHistoryData?.map((item, index) => (
                        <div
                          className={`historyBrief ${selectedIndex === item.id ? "selected" : ""
                            }`}
                          key={item?.id}
                          onClick={() => {
                            handleTitleClick(item?.id)
                          }}
                        >
                          <div className="fui-TreeItemLayout">
                            <div>
                              <span className="historySide"></span>
                            </div>
                            <div className="chatHeading">{item?.text}</div>
                            <div className="chatHeadingDate">
                              {formatTimestamp(item?.timestamp)}
                            </div>
                            <img
                              className="dotMenu1"
                              src={dots}
                              alt="dots"
                              onClick={(e) => handleDotsClick(e, item.id)}
                            />
                          </div>
                          {menuOpenId === item.id && (
                            <div className="menu1">
                              <div
                                className="menuOption"
                                onClick={() => handleDeleteClick(item.id)}
                              >
                                <img className="deleteIcon" src={deleteIcon} alt="delete" />
                                <span>Delete</span>
                              </div>
                            </div>
                           )} 
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </aside>
          )}
          <div className="main-div chatPage" ref={messageSection} id="testing">
            {!assistantHasResponded && <FeatureCard />}
          </div>
          <div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
